module.exports = __webpack_public_path__ + "img/3ds-max.c61342d3.png";